"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Breadcrumbs = exports.BreadcrumbItem = void 0;
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
require("./atoms.pc");
require("./Breadcrumbs.pc.css");
const BreadcrumbItem = ({ onClick, children }) => {
    return (react_1.default.createElement("button", { className: (0, clsx_1.default)('_140c9619', '_5f61cd52', '_pub-5f61cd52', '_pub-6ac1615c'), onClick: onClick }, children));
};
exports.BreadcrumbItem = BreadcrumbItem;
const Breadcrumbs = ({ className, padded, children, }) => {
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('_fa02f735', '_5f61cd52', '_pub-5f61cd52', '_pub-6ac1615c', '_5f61cd52_text-body-medium', '_pub-5f61cd52_text-body-medium', '_pub-6ac1615c_text-body-medium', 'text-body-medium', {
            '_5f61cd52_padded _pub-5f61cd52_padded _pub-6ac1615c_padded padded': padded,
        }, className) }, children));
};
exports.Breadcrumbs = Breadcrumbs;
//# sourceMappingURL=Breadcrumbs.js.map